import { Button, MenuItem, Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useForm } from "react-hook-form";
import RhfTextField from "components/form/RhfTextField";
import { SALES_ORDER_STATUS } from "utils/constants";
import { isAdmin } from "utils/io";

const STATUS_COLORS = {
  Pending: {
    backgroundColor: "#EBEBEB",
    color: "#343434",
    borderColor: "#343434",
  },
  Shipped: {
    backgroundColor: "#F4FFFF",
    color: "#2FAFD3",
    borderColor: "#2FAFD3",
  },
  Complete: {
    backgroundColor: "#E7FFEA",
    color: "#31883C",
    borderColor: "#31883C",
  },
  Completed: {
    backgroundColor: "#E7FFEA",
    color: "#31883C",
    borderColor: "#31883C",
  },
  Cancelled: {
    backgroundColor: "#FFF4F4",
    color: "#D32F2F",
    borderColor: "#D32F2F",
  },
  Returned: {
    backgroundColor: "#FFF4FE",
    color: "#D32FC0",
    borderColor: "#D32FC0",
  },
  "Estimate Sent": {
    backgroundColor: "#F5F2FF",
    color: "#7439E2",
    borderColor: "#7439E2",
  },
  "Delivery Confirmed": {
    backgroundColor: "#dfffefa4",
    color: "#31887eff",
    borderColor: "#31887eff",
  },
  "In Progress": {
    backgroundColor: "#FFF9EA",
    color: "#EFA700",
    borderColor: "#EFA700",
  },
  "Ready to Estimate": {
    backgroundColor: "#EEF5FF",
    color: "#4E8AF9",
    borderColor: "#4E8AF9",
  },
};

const emptySearchInputs = {
  id: "",
  status: "",
  supplier: "",
};

function PurchaseOrderSearchForm({ onSubmit, isSearchDisabled }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: emptySearchInputs,
  });

  const resetForm = () => {
    reset();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack flexDirection="row">
        {isAdmin() ? (
          <RhfTextField
            label="Manufacturer"
            name="supplier"
            control={control}
            size="small"
            sx={{ mr: 2, mb: 2, width: 140 }}
            variant="standard"
          />
        ) : (
          <RhfTextField
            label="ID"
            name="id"
            control={control}
            size="small"
            sx={{ mr: 2, mb: 2 }}
            variant="standard"
          />
        )}
        <RhfTextField
          name="status"
          control={control}
          select
          label="Status"
          size="small"
          variant="standard"
          sx={{ mr: 2, mb: 2, width: 140 }}
        >
          {Object.keys(SALES_ORDER_STATUS).map((key) => {
            const status = SALES_ORDER_STATUS[key];
            return (
              <MenuItem value={status.value} key={status.value}>
                {status.label}
              </MenuItem>
            );
          })}
        </RhfTextField>
        <Button
          sx={{ mr: 2, mb: 2 }}
          color="primary"
          type="submit"
          variant="contained"
          disabled={isSearchDisabled}
        >
          Search
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={resetForm}
          disabled={!isDirty}
          sx={{ mb: 2 }}
        >
          Clear
        </Button>
      </Stack>
    </form>
  );
}

PurchaseOrderSearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSearchDisabled: PropTypes.bool,
};

PurchaseOrderSearchForm.defaultProps = {
  isSearchDisabled: false,
};

export default PurchaseOrderSearchForm;
export { emptySearchInputs, STATUS_COLORS };
